<div class="layout-auto-1 app-config-questionnaire-editor">
  <!-- Header -->
  <div class="search">
    <app-exg-dropdown  *ngIf="currentConfig?.qcnfID"
                       class="typo-small" [list]="availableConfigs" elementclass="typo-left" maxHeight="250px"
                       [label]="currentConfig.qcfgName" position="underright" listdisplay="qcfgName"

                       (change)="changeQuestionnaire($event.value)"
                       [adaptiveHeightActive]="true"
                       [adaptiveHeightOffset]="250">
    </app-exg-dropdown>
    <div class="search-input-bar">{{getRessource('Questionnaire')}} - {{currentConfig.qcnfID}} - {{ currentConfig?.qcfgName}}
    </div>
    <div>
      <i flow="left" class="search-action far fa-plus" (click)="openModalOeQuestionnaireComponent()"
         [tooltip]="getRessource('ElementAddModalTitle')"></i>
      <i flow="left" class="search-action far fa-trash" (click)="deleteElement()"
         [tooltip]="getRessource('ElementDeleteModalTitle')"
         *ngIf="!isLocked"
         [ngClass]="isDeleteAllowed()? '': 'btn-disabled' "></i>
      <i flow="left" class="far fa-arrows-to-line search-action" [tooltip]="getRessource('TooltipCollapseAll')"
         (click)="collapseAllChapter()" [ngClass]="!isMultipleSelect? '': 'btn-disabled' "></i>
      <!--<i class="search-action far fa-copy" *ngIf="!isLocked" flow="left" (click)="showCopyModal()"
         [tooltip]="getRessource('TooltipCopyChapter')" [ngClass]="!isMultipleSelect? '': 'btn-disabled' "></i>-->
      <i class="search-action far fa-clone" *ngIf="!isLocked" flow="left" (click)="duplicateSelectedChapter()"
         [tooltip]="getRessource('TooltipDuplicateChapter')" [ngClass]="(isMultipleSelect
         || ![1, -1].includes(selectedQuest?.quest_enmIdent_questType!))? 'btn-disabled': '' "></i>
      <i flow="left" class="search-action far fa-file-magnifying-glass"
         (click)="openPreviewTab()"
         [tooltip]="getRessource('TooltipPreview')"></i>
      <i class="search-action far fa-list" [ngClass]="isMultipleSelect? 'green' : ''" (click)="toggleSelectMode()"></i>

      <i class="search-action far fa-file-export" [tooltip]="'Export'" flow="left"
         (click)="exportQuestionnaire()"></i>
    </div>
  </div>
  <!-- Content -->
  <div class="grid-auto-1-auto content qba-editor">
    <!-- Element Drag and Drop Sidebar -->
    <div class="content toolbox">
      <div class="layout-auto-1">
        <div class="toolbox-header"><i class="fa fa-tools"></i></div>
        <div
          cdkDropList
          #toolboxList="cdkDropList"
          [cdkDropListData]="toolbox"
          [cdkDropListConnectedTo]="[editorList]"
          cdkDropListSortingDisabled
          class="questionnaire-toolbox-list content"
          (cdkDropListDropped)="drop($event)">
          <div class="questionnaire-toolbox-box" cdkDrag (cdkDragStarted)="onDragStarted(item,i)"
               (cdkDragMoved)="onDragMoved($event)"
               (mouseleave)="toggleTooltip($event, item.tooltip,'close')"
               (mouseenter)="toggleTooltip($event, item.tooltip,'open')"
               [cdkDragDisabled]="isLocked || (questionnaire?.length === 0 && item.quest_enmIdent_questType !== 1)"
               *ngFor="let item of toolbox; let i = index">
            <div *cdkDragPlaceholder class="custom-placeholder"
                 (mouseenter)="setIndex($event, questionnaireIndex , 'p')" flow="left"
                 [tooltip]="getRessource(item.tooltip)"
                 [ngClass]="!checkCopyPossibility()? 'forbidden-drop' : ''"
            ></div>
            <div class="custom-preview" *cdkDragPreview
                 style="width: 300px; padding: 10px; position: relative; background: white">{{item.name}}
              <i class="fa fa-light" [ngClass]="item.icon" style="position: absolute; right: 10px;"></i>
            </div>
            <i class="fa fa-light" [ngClass]="item.icon"
               [ngStyle]="{'opacity':(questionnaire?.length === 0 && item.quest_enmIdent_questType !== 1)? '0.5' : '1' }">
            </i>
            <div class="separator" *ngIf="hasSeparator(i)"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Editor Display and Drop List -->
    <div class="content border-right questionnaire">
      <div
        cdkDropList
        #editorList="cdkDropList"
        [cdkDropListData]="questionnaire"
        class="questionnaire-list content"
        (cdkDropListDropped)="drop(castDrop($event))">
        <ng-container *ngFor="let item of questionnaire; let i = index">
          <div class="questionnaire-box app-qba-questionnaire"
               cdkDrag
               (cdkDragStarted)="onQuestionnaireDragStarted(castDrag(item))"
               [id]="item.questID"
               [style.background-color]="item.quest_Ident === selectedQuest?.quest_Ident? 'var(--c-light-100)' : '' "
               *ngIf="!hiddenItems.includes(item.questID)"
               [cdkDragDisabled]="isOptionDisabled(item) || isLocked"
               [ngClass]="{'example-box-selected': item === selectedQuest,
               'forbidden-drop': !checkMovePossibility(questionnaireIndex)}"
               (click)="setSelectedData(i)" (mouseenter)="setIndex($event, i, 'd')">
            <div class="questionnaire-custom-placeholder" *cdkDragPlaceholder
                 [ngClass]="!checkMovePossibility(questionnaireIndex)? 'forbidden-drop' : ''"
                 (mouseenter)="setIndex($event, i, 'd')"></div>
            <div class="custom-preview" *cdkDragPreview
                 style="width: 600px; padding: 10px; position: relative; background: white">
              <div *ngIf="!isMultipleSelect" class="questionnaire-box" style="margin-bottom: 10px;">
                <ng-container>{{item.quest_Ident}}
                  <ng-container *ngIf="item.questText === ''; else namedContent">{{item.name}}</ng-container>
                </ng-container>
              </div>
              <div *ngIf="isMultipleSelect">
                <div *ngFor=" let sn of selectedItems">
                  <ng-container>{{sn.quest_Ident}}
                    <ng-container *ngIf="sn.questText === ''; else namedPreviewContent">{{sn.name}}</ng-container>
                    <ng-template #namedPreviewContent>{{sn.questText}}</ng-template>
                  </ng-container>
                </div>
              </div>
            </div>
            <!--  container -->
            <div *ngIf="isMultipleSelect"
                 style="text-align: center;align-self: stretch;align-content: center;display: grid;padding: 10px;">
              <i [ngClass]="isItemInSelectedItems(item)? 'fa-square-check' : 'fa-square'"
                 class="fa-regular fa-fw" (click)="setMultipleSelect(item)" *ngIf="isMultipleSelectAvailable(item)"></i>
              <i *ngIf="!isMultipleSelectAvailable(item)"
                 class="fa-regular fa-fw fa-empty"></i>
            </div>
            <div class="list-row list-two-line list-row-auto-1-auto" style="width: 100%;"
                 [style.padding-left.rem]="1 + item.questIdentation">

              <i class="list-icon fa" [style.cursor]="[1, -1].includes(item.quest_enmIdent_questType)? 'pointer': ''"
                 style="margin-right: 0.5rem;"
                 [ngClass]="getIcon(item)"
                 (click)="toggleChildren(item)">
              </i>
              <span>
            <div class="list-primary-text" style=" overflow-wrap: break-word; white-space: normal;">
              <ng-container *ngIf="isChapterHeader(item)">
                <div class="text-n-800" *ngIf="isChapterHeader(item) && item.questPreText">{{item.questPreText}}</div>
                 <img *ngIf="item.FileStream"
                      src="{{'data:' + item?.MIME + ';base64,' + item?.FileStream}}" alt="f"
                      (click)="toggleZoom($event)">
                {{item.quest_Ident}}
                <ng-container *ngIf="item.questText === ''; else namedContent">{{item.name}}</ng-container>
              </ng-container>
              <ng-container *ngIf="isQuestionHeader(item)"> <!--[cdkDragDisabled]="isDisabled(item, i)"-->
                <div class="text-n-800" *ngIf="isQuestionHeader(item)">{{item.questPreText}}
                  <img *ngIf="item.FileStream"
                       src="{{'data:' + item?.MIME + ';base64,' + item?.FileStream}}" alt="f"
                       (click)="toggleZoom($event)">
                </div>
                <ng-container *ngIf="!isUpload(item.quest_enmIdent_questValueFormat)">
                {{item.quest_Ident}}
                  <ng-container *ngIf="item.questText === ''; else namedContent">{{item.name}}</ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="isUpload(item.quest_enmIdent_questValueFormat)">
                <div class="grid-auto-1">
                  <div>{{item.quest_Ident}}
                    <ng-container *ngIf="item.questText === ''; else namedContent">{{item.name}}</ng-container>
                  </div>
                  <div class="md-btn" style="max-width: fit-content;">
                    <ng-container>{{item.name}}</ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="isInput(item.quest_enmIdent_questValueFormat)">
                <div class="grid-input">
                  <input [disabled]="true" class="questionnaire-input" type="text">
                </div>
              </ng-container>
              <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 8">
                <div class="grid-input">
                  <textarea [disabled]="true" type="text"></textarea>
                </div>
              </ng-container>
              <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 15">
                <div class="grid">
                  <i *ngFor="let number of [1,2,3,4,5]" class="far fa-fw fa-star"></i>
                </div>
              </ng-container>
               <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 16">
                 <div class="chips">
                   <div class="chip" tabindex="0">tag<i class="fa fa-close"></i></div>
                   <input class="questionnaire-input input" [disabled]="true" style="height: 1rem;"
                          [placeholder]="getRessource('InputTags')"></div>
              </ng-container>
                <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 17">
                 <div class="grid questionnaire-2dTable">
                          <table id="myTable">
                                <tr>
                                  <th></th>
                                  <ng-container *ngIf="item.configs && item.configs[0] && item.configs[0].cols">
                                   <th class="pointer" id="hg" *ngFor="let col of item.configs[0].cols; let j = index"
                                      [ngClass]="getClassName( undefined, j , 'col', item.questID)"
                                      (click)="selectCol(j)">{{ col.y }}</th>
                                  </ng-container>
                                </tr>
                                <tr *ngFor="let row of item.configs; let i = index" class="pointer"
                                    [ngClass]="getClassName(i, undefined , 'row', item.questID)">
                                  <td style="width:50%;text-align: left;" (click)="selectRow(i)">
                                    <span (click)="selectRow(i)">{{ row.x }}
                                    </span></td>
                                  <td *ngFor="let cell of row.cols; let k = index" (click)="selectCell(i,k)"
                                      class="pointer"
                                      [ngClass]="getClassName(i, k , 'cell', item.questID)">
                                    {{ cell.score }}</td>
                                </tr>
                        </table>
                 </div>
              </ng-container>
              <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 18 && item.questConfiguration">
                <app-exg-form-submit [submitText]="'Speichern'" class="app-custom-html"
                                     [formIdent]="'Form' + item.questKey + 'CmpID' + ComponentUID"
                                     [forceDisable]="true"
                                     [htmlForm]="item.questConfiguration"
                                     [formValues]="undefined"
                ></app-exg-form-submit>
              </ng-container>

              <ng-container *ngIf="item.quest_enmIdent_questValueFormat === 19 && item.questConfiguration && !rerender['ObjectList' + item.questKey + 'CmpID' + ComponentUID]">
                <app-exg-object-list [submitText]="'Speichern'"
                                     [formIdent]="'ObjectList' + item.questKey + 'CmpID' + ComponentUID"
                                     [forceDisable]="true"
                                     [objectMeta]="getJSONObject(item.questConfiguration)"
                ></app-exg-object-list>
              </ng-container>

              <ng-container *ngIf="item.quest_enmIdent_questType === 3">
                <div>
                  <div style="display: flex;">
                    <span style="align-self: center;">{{item.quest_Ident}}</span>
                    <input type="radio" [id]="item.questID" [name]="item.questID" [disabled]="true"
                           *ngIf="[1,2].includes(item.quest_enmIdent_questValueFormat )">
                    <input type="checkbox" [disabled]="true" *ngIf="item.quest_enmIdent_questValueFormat === 3">
                    <label [attr.for]="item.questID">{{item.questText ? item.questText : item.name}}</label>
                  </div>
                </div>
              </ng-container>
            </div>
            </span>
              <span class="list-metadata">
              <i *ngIf="item.quest_kidID && hasKPI(item)" class="far fa-fw fa-key pointer"
                 (click)="openEditMenu(item, 'kid')" [tooltip]="getRessource('TooltipKid')" flow="down"></i>
              <i class="far fa-fw fa-info-circle pointer"
                 *ngIf="item.questHelp.length>0" (click)="openEditMenu(item,'help')"></i>
              <i class="far fa-fw fa-arrows-to-circle pointer"
                 *ngIf="item.questCondition && item.questCondition.length>0" (click)="openEditMenu(item, 'conditional')"></i>
              <i class="far fa-fw fa-running pointer" *ngIf="item.questFollowUpShortText && item.questFollowUpShortText.length>0"
                 (click)="openEditMenu(item,'followup')"></i>
                 <i class="far fa-fw fa-code-fork pointer" *ngIf="hasConditions(item)"
                    (click)="openEditMenu(item,'hasCondition', i)"></i>
                <a *ngIf="item.questLink" href="{{item.questLink}}" rel="noopener" target="_blank">
                  <i class="far fa-fw fa-link"> </i></a>
             <i *ngIf="item.quest_segID" class="fa fa-chart-pie pointer" (click)="openEditMenu(item, 'seg')"></i>
                <i *ngIf="item.questHexCode" class="fas fa-circle" [ngStyle]="{'color':(item.questHexCode)? item.questHexCode:''}"></i>
            </span>
            </div>
          </div>
          <ng-template #namedContent>{{item.questText}}</ng-template>

        </ng-container>
      </div>
    </div>
    <!-- Selected Element Edit -->
    <div class="content border-right property-box">
      <div class="layout-1-auto">
        <div class="border-top content">
          <div class="layout-auto-1-auto">
            <div>
              <div class="search-input-bar md3-masonary-card__title--wrapper">{{getRessource('PropertyHeader')}}</div>
            </div>
            <div class="content property-content">
              <ng-container *ngIf="selectedQuest && !isMultipleSelect">
                <p style="padding-top: 5px;">
                  <em class="typo-small">{{getRessource('LabelElementType')}}:
                    <strong> {{selectedQuest.name}}</strong>
                    <strong *ngIf="selectedQuest.quest_enmIdent_questType === 2"> {{getRessource('Question')}}</strong>
                  </em>
                  <em *ngIf="selectedQuest.questIsOptional"
                      class="typo-small">{{getRessource('OptionalQuestionText')}}</em>
                  <em *ngIf="selectedQuest.questConditional"
                      class="typo-small">{{getRessource('ConditionalQuestionText')}}</em>
                  <em class="typo-small"
                      *ngIf="hasConditions(selectedQuest) && getConditionalElementList(selectedQuest)?.length === 1">
                    {{getRessource('OptionCondition', {ident: getConditionalElementList(selectedQuest)[0]?.quest_Ident})}}</em>
                  <ng-container
                    *ngIf="hasConditions(selectedQuest) && getConditionalElementList(selectedQuest).length > 1">
                    <em class="typo-small">
                      {{getRessource('OptionConditions', {cn: getConditionalElementList(selectedQuest)?.length})}}</em>
                    <strong> <em class="typo-small"
                                 *ngFor="let item of getConditionalElementList(selectedQuest)">{{item.quest_Ident}}
                      - {{item.questText}}</em> </strong>
                  </ng-container>

                </p>
                <ng-container>
                  <exg-textarea name="label"
                                (change)="setChangeMode()"
                                caption="Label"
                                registerOnChange="setChangeMode()"
                                [disabled]="transformIsLockedForDisable(isLocked)"
                                (keyup)="setChangeMode()"
                                [(ngModel)]="selectedQuest.questText"></exg-textarea>

                  <ng-container *ngIf="selectedQuest.quest_enmIdent_questValueFormat === 18">
                    <exg-textarea name="configuration"
                                  [caption]="getClipboardHeader(selectedQuest.quest_enmIdent_questValueFormat)"
                                  [disabled]="'true'"
                                  [(ngModel)]="selectedQuest.questConfiguration"></exg-textarea>
                  </ng-container>

                  <ng-container *ngIf="selectedQuest.quest_enmIdent_questValueFormat === 19">
                    <exg-textarea name="configuration"
                                  [caption]="getClipboardHeader(selectedQuest.quest_enmIdent_questValueFormat)"
                                  [disabled]="'true'"
                                  [(ngModel)]="selectedQuest.questConfiguration"></exg-textarea>
                  </ng-container>

                  <ng-container *ngIf="selectedQuest.quest_enmIdent_questValueFormat === 18 || selectedQuest.quest_enmIdent_questValueFormat === 19">
                    <div style="padding: 0 0.5rem; width: 100%">
                      <button style="width: 98%" class="md-btn-outline" [cdkCopyToClipboard]="copyClipboardElement(selectedQuest)">
                        <i class="fa-fw fas fa-paste"></i>
                        {{getResource('SaveToClipboard')}}
                      </button>
                      <button style="width: 98%" class="md-btn-outline" (click)="pasteClipboardElement(selectedQuest)">
                        <i class="fa-fw fas fa-file-import"></i>
                        {{getResource('CopyFromClipboard')}}
                      </button>
                      <div style="border-bottom: 1px solid var(--c-dark-m1); margin-top: 0.5rem"></div>
                    </div>
                  </ng-container>

                </ng-container>
                <!--<ng-container *ngIf="hasKPI(selectedQuest) && kids">
                  <div class="grid-1-auto">
                    <div class="md-select" [ngClass]="{'closed': closed}">
                      <input #selectInput type="text" placeholder="{{getRessource('InputKid')}}" (input)="filterOptions()"
                             (click)="toggleVisibility()" [(ngModel)]="searchQuery" [disabled]="isLocked"/>
                      <label>{{getRessource('InputKid')}}</label>
                      <i tabindex="-1" class="fa fa-fw fa-chevron-down"></i>
                      <ul class="md-select-values" tabindex="-1" *ngIf="isKidListVisible">
                        <li tabindex="0" class="questionnaire-li" *ngFor="let option of kids" [id]="getID(option.kidID)"
                            [ngClass]="[option.selectable && option.kidID!== selectedQuest.quest_kidID? 'disabled': ''
                          , option.kidID=== selectedQuest.quest_kidID? 'active': '']"
                            (click)="setFocus()" (focus)="selectOption(option, option.selectable )">{{ option.kidName }}
                        </li>
                      </ul>
                    </div>
                    <ng-container *ngIf="selectedQuest.quest_kidID">
                      <i class="search-action far fa-trash" style="margin: 0.75rem 0.75rem 0 0" (click)="deleteCurrentKidOption()"
                      flow="left" [tooltip]="getRessource('TooltipResetKPI')"></i>
                    </ng-container>
                  </div>
                </ng-container>-->
                <ng-container *ngIf="selectedQuest?.quest_enmIdent_questType === 2">
                  <exg-switch name="optional" (change)="setChangeMode()" [disabled]="transformIsLockedForDisable(isLocked)"
                              caption="{{getRessource('InputQuestIsOptional')}}"
                              [(ngModel)]="selectedQuest.questIsOptional"></exg-switch>
                  <exg-switch name="optional" (change)="setChangeMode()" [disabled]="transformIsLockedForDisable(isLocked)"
                              caption="{{getRessource('InputNA')}}"
                              [(ngModel)]="selectedQuest.questIsInapplicable"></exg-switch>
                </ng-container>
                <!--
                 <div class="grid-1-auto">
                  <exg-select *ngIf="selectedQuest?.quest_enmIdent_questType === 1 && segments !== []" [list]="segments"
                              [disabled]="isLocked" [caption]="'Segment'" [listdisplay]="'segName'"
                              [ngModel]="getSegmentIndex(selectedQuest.quest_segID)"
                              (ngModelChange)="setSegment(selectedQuest, $event)"
                  ></exg-select>
                  <i *ngIf="selectedQuest?.quest_segID !== null" class="search-action far fa-trash" style="margin: 0.75rem 0.75rem 0 0" (click)="deleteSegmentLink(selectedQuest)"
                     flow="left" [tooltip]="getRessource('TooltipResetSegment')"></i>
                </div>
                -->
                <exg-textarea name="help" (change)="setChangeMode()" caption="{{getRessource('InputQuesthelp')}}"
                              [disabled]="transformIsLockedForDisable(isLocked)" *ngIf="[1,2 ,-1, 3].includes(selectedQuest.quest_enmIdent_questType)"
                              [(ngModel)]="selectedQuest.questHelp" (keyup)="setChangeMode()"></exg-textarea>
                <div style="padding: 0px 18px 0px 18px;"
                     *ngIf="[1,2 ,-1].includes(selectedQuest.quest_enmIdent_questType) ">

                  <button class="accordion" (click)="toggleDetailAccordion()">
                    {{getRessource('MoreDetails')}}
                    <i class="fa " [ngClass]="detailsIsActive? 'fa-chevron-down': 'fa-chevron-right'"></i>
                  </button>
                  <div *ngIf="detailsIsActive" class="active">
                    <div>
                      <div class="grid-1-auto" style="align-items: end" *ngIf="[1,-1].includes(selectedQuest.quest_enmIdent_questType)">
                        <div class="color-picker">
                          <input type="color" name="hexCode" [id]="'hexCode' + ComponentUID" (ngModelChange)="setChangeMode()" [(ngModel)]="selectedQuest.questHexCode"/>
                          <label [for]="'hexCode' + ComponentUID">Kapitel Farbe</label>
                        </div>
                        <i *ngIf="selectedQuest.questHexCode" class="search-action far fa-trash" style="margin: 0.75rem 0.75rem 0.75rem 0"
                           (click)="selectedQuest.questHexCode = null"
                           flow="left" [tooltip]="'Zurücksetzen'"></i>
                      </div>
                      <exg-input name="AliasText" (change)="setChangeMode()" caption="{{getRessource('InputAliasText')}}"
                                 [disabled]="transformIsLockedForDisable(isLocked)" *ngIf="selectedQuest?.quest_enmIdent_questType === 2"
                                 [(ngModel)]="selectedQuest.questAlias" (keyup)="setChangeMode()"></exg-input>

                      <exg-textarea name="preText" (change)="setChangeMode()" caption="{{getRessource('InputPreText')}}"
                                    [disabled]="transformIsLockedForDisable(isLocked)" *ngIf="selectedQuest?.quest_enmIdent_questType !== 3"
                                    [(ngModel)]="selectedQuest.questPreText" (keyup)="setChangeMode()"></exg-textarea>
                      <exg-input name="Link" (change)="setChangeMode()" caption="{{getRessource('InputLink')}}"
                                 [disabled]="transformIsLockedForDisable(isLocked)" *ngIf="selectedQuest?.quest_enmIdent_questType !== 3"
                                 [hintText]="'https://example.com'"
                                 [(ngModel)]="selectedQuest.questLink" (keyup)="setChangeMode()"></exg-input>
                      <exg-input name="LinkText" (change)="setChangeMode()" caption="{{getRessource('InputLinkText')}}"
                                 [disabled]="transformIsLockedForDisable(isLocked)" *ngIf="selectedQuest?.quest_enmIdent_questType !== 3"
                                 [(ngModel)]="selectedQuest.questLinkText" (keyup)="setChangeMode()"></exg-input>
                      <img *ngIf="selectedQuest.FileStream"
                           style="width: 100%; padding: 0px 20px 0px 20px;"
                           src="{{'data:' + selectedQuest?.MIME + ';base64,' + selectedQuest?.FileStream}}"
                           [alt]="selectedQuest?.questID">
                      <!--<div class="grid cols-1" style="width: 100%; padding: 0px 10px 0px 10px;">
                        <button
                          [tooltip]="getRessource('UploadImage')" flow="down"
                          [disabled]="isLocked || selectedQuest.FileStream"
                          (filesSelect)="fileUpload($event, selectedQuest)" appExgDirectUploadV2 [dnd]="true" #My
                          class="md-btn-outline"
                          [multiple]="false">
                          <i class="fa-fw fas fa-upload"></i>{{' ' + getRessource('UploadImage')}}</button>
                        <button *ngIf="selectedQuest.FileStream" (click)="fileDelete()" class="md-btn-outline"
                                [tooltip]="getRessource('DeleteImage')" flow="down">
                          <i class="fa-fw fas fa-trash"></i> {{' ' + getRessource('DeleteImage')}}</button>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div style="padding: 0px 18px 0px 18px;"
                     *ngIf="selectedQuest?.quest_enmIdent_questValueFormat === 17">
                  <button class="accordion" (click)="toggleTableAccordion()">
                    {{getRessource('TableDetails')}}
                    <i class="fa " [ngClass]="tableDetailsIsActive? 'fa-chevron-down': 'fa-chevron-right'"></i>
                  </button>
                  <div *ngIf="tableDetailsIsActive" class="active">
                    <ng-container *ngIf="selectedColIndex !== null && selectedRowIndex === null && selectedCol">
                      <div class="grid cols-3">
                        <exg-input class="span-3" type="text" [caption]="getRessource('ColTitle')"
                                   (ngModelChange)="changeColTitel(selectedColIndex!,$event)"
                                   [(ngModel)]="selectedCol.y"></exg-input>
                        <button class="md-btn btn-margin" [tooltip]="getRessource('AddColToLeft')" flow="right"
                                (click)="appendCol(selectedColIndex!)"><i class="fa fa-left-from-line"></i></button>
                        <button class="md-btn btn-margin" [tooltip]="getRessource('AddColToRight')" flow="right"
                                (click)="appendCol(selectedColIndex! + 1)"><i class="fa fa-right-from-line"></i></button>
                        <ng-container *ngIf="selectedQuest.configs && selectedQuest.configs[0] && selectedQuest.configs[0].cols">
                          <button class="md-btn btn-margin" [disabled]="selectedQuest.configs[0].cols.length<2"
                                  (click)="deleteColsAtIndex(selectedColIndex!)" [tooltip]="getRessource('DeleteCol')"
                                  flow="left"><i class="fa fa-trash"></i></button>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="selectedRowIndex !== null && selectedColIndex === null && selectedRow">
                      <div class="grid cols-3">
                        <exg-input class="span-3" type="text" *ngIf="selectedRowIndex!== null"
                                   [caption]="getRessource('RowTitle')"
                                   (ngModelChange)="changeRowTitel(selectedRowIndex!,$event)"
                                   [(ngModel)]="selectedRow.x">
                        </exg-input>
                        <button class="md-btn btn-margin" [tooltip]="getRessource('AddRowToBottom')" flow="right"
                                (click)="appendRow(selectedRowIndex! + 1)"><i class="fa fa-down-from-line"></i></button>
                        <button class="md-btn btn-margin" [tooltip]="getRessource('AddRowToTop')"
                                flow="rightupdateScoreAtIndex"
                                (click)="appendRow(selectedRowIndex!)"><i class="fa fa-up-from-line"></i></button>
                        <ng-container *ngIf="selectedQuest.configs">
                          <button [disabled]="selectedQuest.configs.length<2"
                                  [tooltip]="getRessource('DeleteRow')" class="md-btn btn-margin" flow="left"
                                  (click)="deleteRowAtIndex(selectedRowIndex!)"><i class="fa fa-trash"></i>
                          </button>
                        </ng-container>
                      </div>

                    </ng-container>
                    <ng-container *ngIf="selectedRowIndex !== null && selectedColIndex !== null">
                      <exg-input class="span-2" type="number" *ngIf="selectedRowIndex!== null" [caption]="'Score'"
                                 (ngModelChange)="changeCellValue(selectedRowIndex!,selectedColIndex!,$event)"
                                 [(ngModel)]="selectedScore">
                      </exg-input>
                    </ng-container>
                    <ng-container *ngIf="selectedRowIndex === null && selectedColIndex === null">
                      <p>{{getResource('SelectTableDetails')}}</p>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="selectedQuest?.quest_enmIdent_questType === 3">
                  <div class="grid">
                    <exg-input name="Score" caption="Score" (change)="setChangeMode()"
                               [disabled]="transformIsLockedForDisable(isLocked)" type="number" min="0" max="100"
                               [(ngModel)]="selectedQuest.questScore"
                               (keyup)="setChangeMode()"></exg-input>
                    <exg-switch name="optional" (change)="setChangeMode()" [disabled]="transformIsLockedForDisable(isLocked)"
                                caption="{{getResource('InputKO')}}"
                                [(ngModel)]="selectedQuest.questIsKO"></exg-switch>
                    <!--<div style="padding: 0px 18px 0px 18px;">
                      <button class="accordion" (click)="toggleAccordion()">
                        {{getRessource('AddFollowup')}}
                        <i class="fa " [ngClass]="followupIsActive? 'fa-chevron-down': 'fa-chevron-right'"></i>
                      </button>
                      <div class="active" *ngIf="followupIsActive">
                        <div class="grid cols-2">
                          <exg-option class="span-2" [disabled]="transformIsLockedForDisable(isLocked)"
                                      [list]="uiOptions.Values" listdisplay="Name"
                                      [caption]="getResource('SelectDateCaption')"
                                      [(value)]="selectedQuest.followUpType"
                                      (valueChange)="changeFollowUpType($event, selectedQuest)"></exg-option>
                          <exg-input class="span-1" type="number" (change)="setChangeMode()"
                                     (keyup)="setChangeMode()"
                                     [caption]="getRessource('FollowUpDays')" name="questFollowUpDays"
                                     [disabled]="transformIsLockedForDisable(isLocked || selectedQuest.followUpType === 1)"
                                     type="number" min="0"
                                     [(ngModel)]="selectedQuest.questFollowUpDays"></exg-input>
                          <!-[disabled]="dueDateType === 2"->
                          <exg-input (change)="setChangeMode()" type="date" [isEpoch]="true"
                                     (keyup)="setChangeMode()"
                                     [caption]="getRessource('FollowUpDate')" name="questFollowUpFixD"
                                     [disabled]="transformIsLockedForDisable(isLocked || selectedQuest.followUpType === 0)"
                                     [(ngModel)]="selectedQuest.questFollowUpFixD"></exg-input>
                          <!-[disabled]="dueDateType === 1"->
                          <exg-input (change)="setChangeMode()" class="span-2" [required]="true" (keyup)="setChangeMode()"
                                     [caption]="getRessource('FollowUpSText')" name="questFollowUpShortText"
                                     [disabled]="transformIsLockedForDisable(isLocked)"
                                     [(ngModel)]="selectedQuest.questFollowUpShortText"></exg-input>
                          <exg-textarea (change)="setChangeMode()" class="span-2"
                                        [caption]="getRessource('FollowUpDescription')" (keyup)="setChangeMode()"
                                        [disabled]="transformIsLockedForDisable(isLocked)"
                                        name="questFollowUp" [(ngModel)]="selectedQuest.questFollowUp"></exg-textarea>
                        </div>
                      </div>
                    </div>-->
                    <div style="padding: 0px 18px 0px 18px;">
                      <button class="accordion"
                              (click)="toggleConditionalAccordion()">{{getRessource('ManagementConditional') }}
                        <i class="fa fa-chev"
                           [ngClass]="conditionalIsActive? 'fa-chevron-down': 'fa-chevron-right'"></i>
                      </button>
                      <div class="active" *ngIf="conditionalIsActive">
                        <div class="grid content" style="max-height: 255px;">
                          <div
                            style="display: grid; grid-template-columns: minmax(0, 1fr) auto;">
                            <div class="layout-auto-1-auto modal">
                              <div class="grid-table">
                                <div class="grid-table-body">
                                  <div class="grid-table-row grid grid-auto-1"
                                       [tooltip]="getConditionalListTooltip(row)"
                                       [ngClass]="!row.valid ? 'inactive': ''"
                                       *ngFor="let row of freeQuestions; let i = index;">
                                    <exg-checkbox [tiny]="true" [ngModel]="isSelected(i)"
                                                  [disabled]="transformIsLockedForDisable(!row.valid)"
                                                  (change)="onItemSelect(i)">
                                      <div class="md-check-tiny"><input type="checkbox" id="row.questID">
                                        <label for="row.questID"></label></div>
                                    </exg-checkbox>
                                    <div class="cols-1 grid">
                                      <div
                                        [style.padding-left.rem]="1 + row.questIdentation">{{row.quest_Ident.toString() + '-' + row.questText.toString()}}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!selectedQuest && !isMultipleSelect">
                <em style="padding: 10px;">{{getRessource('NoElementSelected')}}</em>
              </ng-container>
              <ng-container *ngIf="isMultipleSelect">
                <em *ngIf="selectedItems.length === 0" style="padding: 10px;">{{getRessource('NoElementSelected')}}</em>
                <em *ngIf="selectedItems.length>1"
                    style="padding: 10px;">{{getRessource('MultipleElementsSelected', {count: selectedItems.length})}}</em>
                <em *ngIf="selectedItems.length === 1"
                    style="padding: 10px;">{{getRessource('OneElementSelected')}}</em>
              </ng-container>
            </div>
            <button class="md-btn" [disabled]="!isChange || !isValidUser() || isLocked" (click)="saveQuestionnaire()">
              {{getGlobal('Save')}}
              <i class="far fa-save" style="right: 0px; position: absolute; padding-right: 4px;font-size: larger;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Custom Tooltip PopUp -->
  <exg-popup #toolTip [closeAlways]="false" [closeOnButtonOnly]="true">
    <div class="md-menu-header"></div>
    <div class="md-menu content customized-tooltip">
      <div class="layout-1-auto">
        <span>{{getRessource(selectedTooltip)}}</span>
      </div>
    </div>
  </exg-popup>
</div>
<!-- Zoomed Image PopUp -->
<exg-popup #image [closeAlways]="false" width="700">
  <div class="md-menu-header"></div>
  <div class="md-menu content" style="max-height: 500px; max-width: 700px">
    <div class="layout-1-auto">
      <img *ngIf="selectedQuest?.FileStream" style="width: 100%; padding: 20px;"
           src="{{'data:' + selectedQuest?.MIME + ';base64,' + selectedQuest?.FileStream}}" alt="ZoomedImage">
    </div>
  </div>
</exg-popup>

